import { createContext } from "react";
import { Vacancy } from "../../../types/vacancyTypes";

interface VacanciesContextType {
    vacancies: Vacancy[];
}

export const VacanciesContext = createContext<VacanciesContextType | undefined>(undefined);
